import { render, staticRenderFns } from "./AddEditGalleryCategory.modal.vue?vue&type=template&id=94701a7c&scoped=true&"
import script from "./AddEditGalleryCategory.modal.vue?vue&type=script&lang=js&"
export * from "./AddEditGalleryCategory.modal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditGalleryCategory.modal.vue?vue&type=style&index=0&id=94701a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94701a7c",
  null
  
)

export default component.exports